import React from 'react';
import Icon from '../../../Icon';
import ButtonComponent from '../../../Components/Button';
import { useTranslation } from 'react-i18next';

const PortfolioHeader = () => {

  const {t} = useTranslation();

  return (
    <div className="sales-tracker-top-page-header">
      <div className="title-wrapper">
        <div className="title-wrapper-icon">
          <Icon type={`portfolio_dashboard`} role={'icon'} />
        </div>
        <div className="sales-tracker-top-page-subheader">
          <h3 className="sales-tracker-top-page-title">
            {t(`Portfolio`)}
          </h3>
          <h4 className="sales-tracker-top-page-subtitle">
            {t(`Receive winning products on a weekly basis`)}
          </h4>
        </div>
      </div>
      <ButtonComponent className={'sales-tracker-top-page-header-btn'}
                       text={null}
                       onClick={null}
      >
        <Icon type={'three_dots'} role={'icon'} />
      </ButtonComponent>
    </div>
  );
};

export default PortfolioHeader;
